export function getCookie(name) {
  if (process.env.REACT_APP_ENVIRONMENT === "development") {
    return "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS11YXQubWF3YWxvZy5jb20vYWRtaW4vdjIvYXBpL2xvZ2luIiwiaWF0IjoxNzc1MTA1MDQ5LCJleHAiOjE3NzUxOTE0NDksIm5iZiI6MTc3NTEwNTA0OSwianRpIjoiVjFURXRiZXkwb2R3UFF4TiIsInN1YiI6IjEyMzIiLCJwcnYiOiI5YWQ1ODU3N2ZhYjZmYmMxNTU0MzRkMzU5MWVkZjE2NGExNzc2NWFhIiwiYXV0aGlkIjoxMjMyLCJvcmdpZCI6MTA1LCJ1c2VyaWQiOjEyMzIsImRhdGFiYXNlbmFtZSI6InJhZ3VyciIsIm9yZ19jb2RlIjoicmFndXJyIiwidGltZXpvbmUiOiIgKyBpbnRlcnZhbCAnMDUgaG91cnMgMzAgbWludXRlcyciLCJyb2xlaWQiOjQ5NywicGF5bWVudF9zdGF0dXMiOnRydWUsImF1dGhvcml0aWVzIjpbIlJPTEVfVVNFUiJdLCJkZXZpY2VfaWQiOiI5NDQzYzA5Yi1kNjhhLTQ0NTUtOTViNy0yN2JjMWRjYjQwMDgifQ.UQxl5i1qVsQnuh3AA-LADBLj3zohFyO62oQ7EHJU31E";
  }
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const cookieString = document.cookie;
  console.log(cookieString);
  const cookies = cookieString.split(";");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(name + "=")) {
      if (cookie.substring(name.length + 1) === "") {
        const currentURL = window.location.href;

        const redirectData = {
          redirectPath: currentURL,
          app: "asset",
          ts: Date.now(),
        };

        console.warn("🔐 Saving redirect in window.name:", redirectData);

        // ✅ TAB-SPECIFIC, CROSS-DOMAIN SAFE
        window.name = JSON.stringify(redirectData);
        window.location.href = `${accountsUrl}/login`;
      }
      return cookie.substring(name.length + 1);
    }
  }
  // window.location.href = accountsUrl;
  return null;
}
